<template>
  <div v-if="isOpen" class="modal-container">
    <div class="fixed inset-0 bg-black/50 backdrop-blur-sm z-40"></div>
    <div
      class="modal-content w-full max-w-md relative bg-white dark:bg-secondary m-auto flex-col flex rounded-lg z-50 shadow-xl border border-border"
    >
      <div class="w-full border-b border-border mb-4 px-6 py-4">
        <h2
          class="text-[18px] text-foreground dark:text-primaryLight font-medium"
        >
          Are you sure you want to delete
          <span class="font-bold">{{ projectName }}</span
          >?
        </h2>
      </div>

      <form @submit.prevent="deleteProject" class="overflow-y-auto px-6">
        <div class="mb-4">
          <p class="text-sm text-muted-foreground mb-4">
            This action cannot be undone. This will permanently delete the
            project and all associated data.
          </p>
          <label
            class="block text-sm font-medium text-foreground dark:text-gray-300"
          >
            To confirm, type "delete" in the box below
          </label>
          <input
            type="text"
            v-model="confirmationText"
            placeholder="Type delete"
            class="mt-1 block w-full px-3 py-2 bg-white dark:bg-muted border border-border dark:border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500/50 focus:border-red-500 sm:text-sm text-foreground"
            required
          />
        </div>
        <div class="flex justify-end gap-3 mb-6">
          <button
            type="button"
            class="py-2 px-4 bg-transparent border border-border text-foreground dark:text-gray-300 rounded-md hover:bg-muted transition-colors text-sm"
            @click="$emit('close')"
          >
            Cancel
          </button>
          <button
            type="submit"
            :class="[
              'py-2 px-4 h-[40px] text-white rounded-md text-sm font-medium transition-all shadow-sm',
              confirmationText === 'delete'
                ? 'bg-red-600 hover:bg-red-700'
                : 'bg-gray-300 dark:bg-gray-700 cursor-not-allowed opacity-50',
            ]"
            :disabled="confirmationText !== 'delete'"
          >
            Delete project
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeleteProjectModal",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    projectId: {
      type: [String, Number],
      required: true,
    },
    projectName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      confirmationText: "",
    };
  },
  methods: {
    deleteProject() {
      if (this.confirmationText === "delete") {
        this.$emit("confirm-delete", this.projectId);
        this.confirmationText = "";
      }
    },
  },
  watch: {
    isOpen(newVal) {
      if (!newVal) {
        this.confirmationText = "";
      }
    },
  },
};
</script>

<style scoped>
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 60;
}

.modal-content {
  max-height: 90vh;
  overflow-y: auto;
  margin: 20px;
  z-index: 70;
}
</style>
